/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { defineMessages } from 'react-intl';
import { BasicModal, BasicModalProps } from 'src/core/components/BasicModal';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { withModalMounter } from 'src/core/utils/hocs/withModalMounter';

const messages = defineMessages({
    modalTitle: {
        id: 'qnaMaker.qnaMakerDiscardModal.modalTitle',
        defaultMessage: 'Discard changes'
    },
    description: {
        id: 'qnaMaker.qnaMakerDiscardModal.description',
        defaultMessage: 'Are you sure you want to discard all your unsaved changes?'
    }
});

export const QnaMakerDiscardModal = withModalMounter((props: BasicModalProps<object>) => {
    const { onDismiss } = props;
    const { localize } = useLocalization();

    return (
        <BasicModal
            {...props}
            valid
            minWidth={560}
            shouldRenderFooter
            onDismiss={onDismiss}
            dialogContentProps={{ title: localize(messages.modalTitle) }}>
            <LuisText>{localize(messages.description)}</LuisText>
        </BasicModal>
    );
});
